<template>
  <div style="margin-top: -1.5rem">
    <ExploreSearchBar />
    <StackExplore />
    <ExploreLearningUnit />
  </div>
</template>

<script>
/* Customized Components */
import StackExplore from './components/StackExplore.vue';
import ExploreSearchBar from './components/ExploreSearchBar.vue';
import ExploreLearningUnit from './ExploreLearningUnit.vue';

export default {
  name: 'PageLearningUnit',

  components: {
    StackExplore,
    ExploreSearchBar,
    ExploreLearningUnit
  }
};
</script>
